/// <reference types="vite-plugin-pwa/react" />
import { useRegisterSW } from "virtual:pwa-register/react";

// Aviso de versión nueva (Kevin, 10-oct-2026). El service worker está en modo «prompt»: la versión nueva
// queda ESPERANDO hasta que alguien la acepte, y nunca hubo pantalla que preguntara. Resultado medido: el
// equipo de Kevin siguió con la app de fines de septiembre aunque se publicó el 29-sep, el 9-oct y el
// 10-oct (su cuenta ya era Dueño en el servidor y la pantalla seguía diciendo «Encargado»).
// No se recarga sola: en el mostrador hay una venta a medio armar. La cola de ventas vive en el equipo
// (IndexedDB) y sobrevive a la recarga; el carrito en pantalla no.

const CADA_30_MIN = 30 * 60 * 1000;

export function AvisoVersion() {
  const {
    needRefresh: [hayNueva, setHayNueva],
    updateServiceWorker,
  } = useRegisterSW({
    // Con la app abierta todo el día, el navegador no busca versiones nuevas solo: se le pide cada 30 min.
    onRegisteredSW(_url, registro) {
      if (registro) setInterval(() => void registro.update(), CADA_30_MIN);
    },
  });

  if (!hayNueva) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-3 top-3 z-50 mx-auto flex max-w-[560px] flex-wrap items-center gap-3 rounded-[12px] border border-line-input bg-card px-4 py-3 shadow-lg"
    >
      <p className="min-w-[200px] flex-1 text-[13px] leading-snug text-ink">
        <span className="font-semibold">Hay una versión nueva del sistema.</span> Si estás cobrando, termina la venta y luego actualiza.
      </p>
      <div className="flex gap-1.5">
        <button
          onClick={() => setHayNueva(false)}
          className="min-h-[44px] rounded-[9px] px-3 text-[12.5px] text-ink-2 hover:bg-hover-btn sm:min-h-[34px]"
        >
          Luego
        </button>
        <button
          onClick={() => void updateServiceWorker(true)}
          className="min-h-[44px] rounded-[9px] bg-accent px-4 text-[12.5px] font-semibold text-white hover:bg-accent-hover sm:min-h-[34px]"
        >
          Actualizar ahora
        </button>
      </div>
    </div>
  );
}
